import { useMutation, useQueryClient } from '@tanstack/react-query';

import { queryKeysSupplier } from '../queryKeys';

import { type UpdateActivationAutoFollowUpMutationOptions } from './types';
import { updateActivationAutoFollowUp } from './updateActivationAutoFollowUp';

/**
 * Updates automatic follow-up for an activation request batch.
 *
 * Activation detail and list queries are invalidated because the setting
 * applies to every document type sent in the same batch.
 */
export function useMutationUpdateActivationAutoFollowUp(
  options?: UpdateActivationAutoFollowUpMutationOptions,
) {
  const queryClient = useQueryClient();
  const { onSettled, ...mutationOptions } = options ?? {};

  return useMutation({
    throwOnError: false,
    ...mutationOptions,
    mutationFn: async ({ reqId, payload }) =>
      updateActivationAutoFollowUp(reqId, payload),
    async onSettled(data, error, variables, onMutateResult, context) {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: queryKeysSupplier.getActivationRequest(undefined),
        }),
        queryClient.invalidateQueries({
          queryKey: queryKeysSupplier.getActivationRequests(undefined),
        }),
      ]);

      return onSettled?.(data, error, variables, onMutateResult, context);
    },
  });
}
